import { createSale, getPaymentMethods } from '../../sales/infra/salesRepo';
import { fetchCustomerAccounts, countCustomerAccounts } from '../../customers/infra/customerAccounts';
import { getMergedActiveCashSessionId } from '../../cash/infra-api';
import type { PosCheckoutCustomerOption } from '../domain/posTypes';

function mapCheckoutCustomers(
  rows: Awaited<ReturnType<typeof fetchCustomerAccounts>>
): PosCheckoutCustomerOption[] {
  return rows.map((c) => ({
    id: c.id,
    name: c.name,
    phone: c.phone ?? null,
    balance: c.balance,
    creditLimit: c.creditLimit,
    blocked: c.blocked,
    priceListId: c.priceListId ?? null,
    cuit: c.cuit ?? null,
    taxCondition: c.taxCondition ?? null,
    businessName: c.businessName ?? null,
  }));
}

export async function listPosCheckoutCustomers(opts?: {
  limit?: number;
  offset?: number;
}): Promise<PosCheckoutCustomerOption[]> {
  return mapCheckoutCustomers(await fetchCustomerAccounts(opts));
}

export async function countPosCheckoutCustomers(): Promise<number> {
  return countCustomerAccounts();
}

export async function loadOpenCheckoutContext(params: {
  branchId: string;
  customerMethodAllowed: boolean;
  mercadopagoQrMethodAllowed: boolean;
  checkMethodAllowed: boolean;
}) {
  const [methodsRaw, customers, customersTotal, cashSession] = await Promise.all([
    getPaymentMethods(),
    params.customerMethodAllowed ? listPosCheckoutCustomers({ limit: 5, offset: 0 }) : Promise.resolve([]),
    params.customerMethodAllowed ? countPosCheckoutCustomers() : Promise.resolve(0),
    getMergedActiveCashSessionId(params.branchId).then((sessionId) =>
      sessionId ? { id: sessionId } : null
    ),
  ]);
  const methods = methodsRaw.filter(
    (m) =>
      (m.id !== 'mercadopago_qr' || params.mercadopagoQrMethodAllowed) &&
      (m.id !== 'fiado' || params.customerMethodAllowed) &&
      (m.id !== 'cheque' || params.checkMethodAllowed)
  );
  return {
    methods,
    customers,
    customersTotal,
    activeCashSessionId: cashSession?.id ?? null,
  };
}
